import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import history from '../../../history'
import { KEY_CODES } from '../../../constants/utility'
import { Unless, Button, If, Text } from '../..'
import { IconPlayCircle } from '../Icon'

import styles from './ImportantNowCard.module.scss'

const propTypes = {
  navTo: PropTypes.string.isRequired,
  svgImage: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  imageUrl: PropTypes.string,
  hide: PropTypes.bool,
  event: PropTypes.func,
  navMessage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
    values: PropTypes.object,
  }),
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.any,
  'data-qa': PropTypes.string,
}

const defaultProps = {
  imageUrl: null,
  svgImage: null,
}

const ImportantNowCard = ({
  hide,
  event,
  svgImage: WinImage,
  imageUrl,
  navTo,
  navMessage,
  onClick,
  className,
  children,
  ...restProps
}) => {
  const handleClick = () => {
    event?.()
    navTo && history.push(navTo)
    onClick && onClick()
  }

  const handleKeyDown = () => e =>
    (e.which || e.keyCode) === KEY_CODES.enter && handleClick()

  return (
    <Unless condition={hide}>
      <div className={classnames(styles.card, className)} {...restProps}>
        <If condition={!imageUrl && !!WinImage}>
          <div className={styles.svgWrapper}>
            <WinImage />
          </div>
        </If>
        <If condition={!!imageUrl}>
          <div
            className={styles.imgWrapper}
            style={{ backgroundImage: `url(${imageUrl})` }}
          >
            <IconPlayCircle className={styles.playIcon} />
          </div>
        </If>
        <div className={styles.contentWrapper}>
          <Text element='span' variant='neutralCool' variantCount='600'>
            {children}
          </Text>
        </div>
        <Button
          minimal
          className={styles.navButton}
          onKeyDown={handleKeyDown}
          onClick={handleClick}
          data-qa={restProps['data-qa'] || 'important-now-spotlight-button'}
        >
          <FormattedMessage
            id='ImportantNow.card.button.default'
            defaultMessage='Get more details'
            {...navMessage}
          />
        </Button>
      </div>
    </Unless>
  )
}

ImportantNowCard.propTypes = propTypes
ImportantNowCard.defaultProps = defaultProps

export default ImportantNowCard
